import React from "react";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Matches from "../pages/UserManagement/Matches";
import Login from "../pages/Authentication/Login";
import UsersList from "../pages/UserManagement/UsersList";
import UserDetail from "../pages/UserManagement/UserDetail";



const authProtectedRoutes = [
  { path: "dashboard", component: Dashboard },
  { path: "user/list", component: UsersList },
  { path: "user/detail/:userId", component: UserDetail },
  { path: "user/match/:id", component: Matches },
  { path: "user/match", component: Matches },
];

const publicRoutes = [
  { path: "/login", component: Login },
];

export { authProtectedRoutes, publicRoutes };
